var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"}),_c('div',{staticClass:"column"},[_c('CardCustom')],1),_c('div',{staticClass:"column"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }